import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import { AsideData } from './AsideData';
import '../styles/Aside2.css';


function Aside2() {
  
  return (
    <>
      <aside className="sidenav navbar navbar-vertical navbar-left navbar-expand-xs border-0 border-radius-xl my-3 fixed-start ms-3 bg-gradient-dark" id="sidenav-main">
      <div className="sidenav-header">
        <i className="fas fa-times p-3 cursor-pointer text-white opacity-5 position-absolute end-0 top-0 d-none d-xl-none" aria-hidden="true" id="iconSidenav"></i>
        <a className="navbar-brand m-0" href="/dashboard" target="_blank">
          <img src="../assets/img/logo200.png" className="navbar-brand-img h-100" alt="main_logo"/>
          <span className="ms-1 font-weight-bold text-white">FamilyRun Customer</span>
        </a>
      </div>
      <hr className="horizontal light mt-0 mb-2"/>
      <nav className='navbar'>
        <ul className='navbar-nav'>
          {AsideData.map((item, index) => {
            return (
              <li key={index} className={item.cName}>
                <Link to={item.path} className='nav-link text-white'>
                  <div className='text-white text-center me-2 d-flex align-items-center justify-content-center'>
                  <i className="material-icons opacity-10">{item.icon}</i>
                  </div>
                  <span className="nav-link-text ms-1">{item.title}</span>
                  
                </Link>
              </li>
            )
          })}
        
        </ul>

      </nav>
      </aside>
      
    </>
  )
}
export default Aside2

